import { Back } from "iconsax-react";
import React from "react";
import { Link, Outlet, useLoaderData, useLocation } from "react-router-dom";

export const indexLoader = async ({ params }) => {
  return { id: params.id };
};

const PatientPage = () => {
  const { id } = useLoaderData();
  const location = useLocation();
  const tabs = [
    {
      id: 1,
      title: "Patient Info",
      href: `/dashboard/patients/${id}`,
    },
    {
      id: 2,
      title: "Patient Orders",
      href: `/dashboard/patients/${id}/orders`,
    },
    {
      id: 3,
      title: "Patient Notes",
      href: `/dashboard/patients/${id}/notes`,
    },
    {
      id: 3,
      title: "Patient Forms",
      href: `/dashboard/patients/${id}/forms`,
    },
  ];

  return (
    <div className={`max-h-[100vh] bg-white overflow-y-scroll scrollbar-hide`}>
      <div className="sticky left-0 right-0 top-0 z-10">
        <div className="bg-[#fafafa] px-10 py-5 flex flex-col sm:flex-row gap-x-3 sm:items-center">
          <Link
            to="/dashboard/patients"
            className="hover:text-primary duration-300"
          >
            <Back size="32" />
          </Link>
          <p className="text-[18px] font-medium">
            Patient Management - #{id}
          </p>
        </div>

        <div className="bg-[#fafafa] px-7 flex border-t border-b overflow-x-scroll scrollbar-hide whitespace-nowrap">
          {tabs.map((item) => (
            <Link
              to={item.href}
              key={item.id}
              className={`${
                location.pathname === item.href
                  ? "bg-[#00b0ad0d] border-[#00B0AD] text-black font-medium"
                  : "font-medium text-gray-800 border-b-transparent"
              } border-t-[3px] border-t-transparent border-b-[3px]  cursor-pointer p-3 text-[13px] select-none`}
            >
              {item.title}
            </Link>
          ))}
        </div>
      </div>
      <Outlet />
    </div>
  );
};

export default PatientPage;
